import { useState } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { useFontPairings, FontPairing } from 'hooks/queries/fontPairings'
import { FontPairingCard, FontPairingCardSkeleton } from 'components/FontPairingCard'
import Styles from './FontPairingsModal.module.scss'

export interface FontPairingsModalProps {
  selectedFontPairingId: number | null
  onConfirm: (fontPairingId: number) => void
  title?: string
}

export const FontPairingsModal = ({
  selectedFontPairingId: initialSelectedId,
  onConfirm,
  title = 'Select a font pairing',
}: FontPairingsModalProps) => {
  const { closeModal } = useModals()
  const { data: fontPairings, isLoading } = useFontPairings()
  const [selectedFontPairingId, setSelectedFontPairingId] = useState<number | null>(initialSelectedId)

  const handleConfirm = () => {
    if (selectedFontPairingId !== null) {
      onConfirm(selectedFontPairingId)
      closeModal()
    }
  }

  return (
    <Modal.Root size="lg" onPressOutside={closeModal}>
      <Modal.Header title={title} />
      <Modal.Content>
        <div className={Styles.grid}>
          {isLoading && [1, 2, 3, 4].map((i) => <FontPairingCardSkeleton key={i} />)}
          {!isLoading &&
            fontPairings?.map((fontPairing: FontPairing) => (
              <FontPairingCard
                key={fontPairing.id}
                fontPairing={fontPairing}
                isSelected={selectedFontPairingId === fontPairing.id}
                onSelect={() => setSelectedFontPairingId(fontPairing.id)}
                withBorder={false}
              />
            ))}
        </div>
      </Modal.Content>
      <Modal.Footer sticky className={Styles.footer}>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleConfirm} isDisabled={selectedFontPairingId === null}>
            Confirm Selection
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
